import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider as ReduxProvider } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { DndProvider } from 'react-dnd';
import 'react-toastify/dist/ReactToastify.css';
import './styles/index.scss';
import './helpers/i18n';
import { store } from './store';
import App from './components/app';
import Loading from './components/extra-pages/Loading';
const container = document.getElementById('plugNmeet-app');
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const root = createRoot(container);
root.render(_jsx(React.StrictMode, { children: _jsx(ReduxProvider, { store: store, children: _jsxs(DndProvider, { backend: HTML5Backend, children: [_jsx(Suspense, { fallback: _jsx(Loading, { text: "" }), children: _jsx(App, {}) }), _jsx(ToastContainer, {})] }) }) }));
